const Theme = {
  body_background_color: '#fff2e6',
  // body_background_image_url: '',
  body_background_image_repeat: false,
  body_background_image_contain: false,

  // card_background_color: '',
  // card_background_image_url: '',
  // card_background_image_repeat: false,
  // card_max_width: 0,
  // card_text_centered: false,
  // card_fullscreen: false,
  // card_header_margin_top: 0,

  // header_background_color: '',
  // header_background_url: '',
  // header_background_image_repeat: false,
  // header_full_height: false,
  // header_padding: 0,
  // header_height: 0,
  header_hidden: true,
  // header_border_color: '',
  // header_border_style: '',
  // header_border_height: 0,
  // header_no_margin: false,

  // logo_image_url: '',
  // logo_height: 0,
  // logo_hidden: false,
  // logo_scale: 1,
  // logo_background_color: '',
  // logo_padding: 0,

  card_header_image_as_title: '',
  card_header_image_top: 'monparcoursmm_secondaire.svg',
  card_header_title_centered: false,
  card_header_title_hidden: false,
  card_header_b_color: '',
  card_header_negative_margin: false,
  card_header_hidden: false,

  token_url: 'monparcoursmm/pastille.png',
  // tokens: [''],
  token_width: 0,
  token_hidden: false,
  // token_hidden_tokenIds: [0],
  // token_margin_left: 0,
  // token_margin_right: 0,
  // token_margin_top: 0,
  // token_padding_top: 0,
  // token_border: '',
  // token_border_radius: 0,

  number_font: 'Hobeaux Black',
  number_weight: 0,
  number_size: 0,
  number_color: 'white',
  number_background: '',
  number_hidden: false,
  number_hidden_tokenIds: [0],
  number_top: 0,
  number_left: 0,

  image_icon_hidden: false,
  image_icon_background_color: '',
  image_icon_border_color: '',
  image_margin: 0,

  // button_border_color: '',
  button_color: '#FF592C',
  button_hover_color: '#fff2e6',
  button_hover_text_color: '#91241E',
  // button_hover_border_color: '',
  // button_outlined_color: '',
  // button_outlined_text_color: '',
  // button_outlined_hover_color: '',
  // button_outlined_hover_border_color: '',
  // button_outlined_hover_text_color: '',
  // button_font: '',
  // button_text_lineheight: 0,
  button_text_size: 18,
  // button_text_color: '#91241E',
  // button_text_weight: 0,
  // button_text_uppercase: false,
  // button_text_letter_spacing: 0,
  button_radius: 25,
  // button_shadow: '',
  // button_padding: '',
  // button_width: 0,
  button_centered: false,
  button_border_width: 0,
  button_no_border: true,
  button_outlined_as_default: false,

  button_half_border_color: '',
  button_half_max_width: 0,
  button_half_align_label_left: false,
  button_half_underline: false,
  button_half_underline_color: '',
  button_half_underline_width: 0,
  button_half_underline_height: 0,
  button_half_font: '',
  button_half_text_weight: 0,
  button_half_text_size: 0,
  button_half_text_color: '',
  button_half_resize_label: false,

  text_font: `RooneySans Light`,
  title_font: `Hobeaux Black`,
  subtitle_font: `Hobeaux Bold`,
  // subtitle_font_h3: 'Rooney Light Sans',
  // text_color: '',
  // text_centered: false,
  // text_size: 0,
  // text_lineheight: 0,
  // text_weight: 0,
  // text_margin_left: 0,
  // text_list_style_type: '',
  // text_text_decoration: '',

  // title_color: '',
  // title_background: '',
  // title_italic: false,
  // title_uppercase: false,
  // title_shadow: '',
  // title_centered: false,
  // title_size: 0,
  // title_lineheight: 0,
  // title_letter_spacing: 0,
  // title_weight: 0,
  // title_margin: '',

  // subtitle_font_h3: 'Rooney Sans Light Italic',
  // subtitle_color: '',
  // subtitle_background: '',
  // subtitle_size: 22,
  // subtitle_lineheight: 40,
  // subtitle_letter_spacing: 0,
  // subtitle_weight: 0,
  // subtitle_margin: 0,
  // subtitle_uppercase: false,
  // subtitle_text_transform: 'none',
  // subtitleH3_color: 'none',
  // subtitleH3_font_size: '22',

  // list_item_subtitle_weight: 0,
  // list_border_bottom: '',

  // footer_background_color: '',
  // footer_border_color: '',
  // footer_border_height: 0,
  // footer_border_hidden: false,
  // footer_border_radius: 0,
  // footer_border_style: '',
  // footer_font: '',
  // footer_hidden: false,
  // footer_img_top_margin: 0,
  // footer_img_top: '',
  // footer_margin: 0,
  // footer_text_color: '',
  // footer_link_color: '',
  // footer_text_size: 0,
  // footer_text_weight: 0,
}

export default Theme